import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=cc3735c0&scoped=true"
var script = {}
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=cc3735c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3735c0",
  null
  
)

export default component.exports